import React, { useContext, useState } from 'react';
import { DropdownWrapper, Header, HeaderButtons } from '../styles';
import ViewportContext from '../../../../../components/viewport/context';
import SortOptionsBase from '../offer-list-sorting/sort-options-base';
import FilterToggleButton from '../offer-list-filters/components/filter-toggle-button';
import FilterOptionsPanel from '../offer-list-filters/components/filter-options-panel';
import { ProductConditionSummary, VariantGroup } from 'src/types';

const PriceListHeader: React.VFC<IPriceListHeader> = props => {
  const { isMobile } = useContext(ViewportContext);
  const [showFilters, setShowFilters] = useState<boolean>(false);

  return (
    <Header data-test="PricePanelHeader">
      <HeaderButtons>
        <DropdownWrapper>
          <FilterToggleButton onToggle={setShowFilters} />
        </DropdownWrapper>
        <DropdownWrapper>
          <SortOptionsBase compact={isMobile} />
        </DropdownWrapper>
      </HeaderButtons>
      <FilterOptionsPanel
        visible={showFilters}
        conditions={props.conditions}
        variantGroups={props.variantGroups}
        categoryId={props.categoryId}
      />
    </Header>
  );
};

interface IPriceListHeader {
  variantGroups?: VariantGroup[] | null;
  conditions: ProductConditionSummary[];
  categoryId: string | undefined;
}

export default PriceListHeader;
